import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, { useState } from 'react'
import { useSpring, animated } from 'react-spring'
import swal from 'sweetalert'
import * as Yup from 'yup'

const Register = () => {
  const initValues= {
    name : "",
    origin: "",
    phoneNumber: "",
    course: "",
  } 

  const [loading, setLoading] = useState(false)

  const gameOver = useSpring({
    from:{ opacity: 0, marginTop: -1000 },
    to:{ opacity: 1, marginTop: 0 }
  })

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/


  const validationSchema = Yup.object().shape({
    name: Yup
      .string()
      .matches(/^[A-Za-z ]*$/, 'Please enter valid name')
      .min(3)
      .max(40)
      .required("Required"),
    origin: Yup
      .string()
      .matches(/^[A-Za-z ]*$/, 'Please enter valid name')
      .min(3)
      .max(40)
      .required("Required"),
    phoneNumber: Yup
      .string()
      .required("Required")
      .matches(phoneRegExp, 'Phone number is not valid')
        
  })

  const onSubmit = (data, { resetForm }) => {
    setLoading(true)

    swal({
      icon: 'success',
      title: 'Your Info',
      text: JSON.stringify(data),
      buttons: true
    }).then(r => {
      resetForm()
      setLoading(false)
    })
    
  }

  return (
    <animated.div style={gameOver} className='py-7 w-full font-poppins flex items-center justify-center px-5 text-black'>
      <Formik
        initialValues={initValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >

        {({ errors, touched, dirty, isValid }) => (
            <Form className='flex flex-col w-full sm:max-w-[365px] ss:max-w-[365px] md:max-w-2xl  gap-y-2'>
                <h1 className='text-[28pt] font-semibold'>Register for classes</h1>
                <div className='flex md:flex-row flex-1 flex-col gap-3 shadow-xl max-w-2xl py-6 px-2 rounded-2xl'>
                    <div className='flex flex-col flex-1 items-start p-2 gap-y-4 ' >
                        <div className="flex flex-col items-start gap-y-1 w-full">
                            <label htmlFor=""
                                className="text-lg px-2 font-semibold font-poppins text-primary"
                            >
                              Full Name* :
                            </label>
                            <div className='flex w-full animate-pulse flex-row items-end text-black font-medium justify-end px-2'>
                                <ErrorMessage name='name'/>
                            </div>
                            <Field
                                id="name" 
                                name="name"
                                className={touched.name && errors.name ? 
                                "w-full p-3 rounded-lg px-5 text-red-800 border-2 border-red-700" :
                                "w-full p-3 rounded-lg px-5 text-black border-2 border-gray-600"}
                                autoComplete="off"
                            />
                        </div>

                        <div className="flex flex-col items-start gap-y-1 w-full">
                            <label htmlFor=""
                                className="text-lg px-2 font-semibold font-poppins text-primary"
                            >
                                Place of Origin* :
                            </label>
                            <div className='flex w-full animate-pulse flex-row items-end text-black font-medium justify-end px-2'>
                                <ErrorMessage name='origin'/>
                            </div>
                            <Field
                                name="origin"
                                id="origin"
                                className={touched.origin && errors.origin ? 
                                "w-full p-3 rounded-lg px-5 text-red-800 border-2 border-red-700" :
                                "w-full p-3 rounded-lg px-5 text-black border-2 border-gray-600"}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className='flex flex-col flex-1 items-start p-2 gap-y-4' >
                        <div className="flex flex-col items-start gap-y-1 w-full">
                            <label htmlFor=""
                                className="text-lg px-2 font-semibold font-poppins text-black"
                            >
                                Phone Number* :
                            </label>
                            <div className='flex w-full animate-pulse flex-row items-end text-black font-medium justify-end px-2'>
                                <ErrorMessage name='phoneNumber'/>
                            </div>
                            <Field
                                type="text"
                                id="phoneNumber" 
                                name="phoneNumber"
                                className={touched.phoneNumber && errors.phoneNumber ? 
                                "w-full p-3 rounded-lg px-5 text-red-800 border-2 border-red-700" :
                                "w-full p-3 rounded-lg px-5 text-black border-2 border-gray-600"}
                                autoComplete="off"
                            />
                        </div>

                        <div className="flex flex-col items-start gap-y-1 w-full">
                            <label htmlFor=""
                                className="text-lg px-2 font-semibold font-poppins text-primary"
                            >
                                Select Course* :
                            </label>
                            <div className='flex w-full animate-pulse flex-row items-end text-black font-medium justify-end px-2'>
                                <ErrorMessage name='course'/>
                            </div>
                            <Field
                              name="course"
                              id="course"
                              as="select"
                              className={ touched.course && errors.course ?
                              "w-full p-3 rounded-lg px-5 text-red-800 border-2 border-red-500" :
                              "w-full p-3 rounded-lg px-5 text-black border-2 border-gray-300"
                              }
                            >
                              <option value="Poultry production">Poultry production</option>
                              <option value="Small non-ruminant animal production">Small non-ruminant animal production</option>
                              <option value="Maize Production">Maize Production</option>
                              <option value="Winter Cropping">Winter Cropping</option>
                              <option value="Sheep and goat production">Sheep and goat production</option>
                              <option value="Soya production">Soya production</option>
                              <option value="Tomato Production ">Tomato Production </option>
                              <option value="Ground nuts Production">Ground nuts Production </option>
                              <option value="Tobacco Production">Tobacco Production </option>
                              <option value="Vegetable Production">Vegetable Production</option>
                              <option value="Pepper Production">Pepper Production </option>
                              <option value="Fruit Production">Fruit Production</option>
                              <option value="Pig Farming">Pig Farming</option>
                              <option value="Quail farming">Quail Farming</option>
                              <option value="Poultry">Poultry farming</option>
                              <option value="Sunflower">Sunflower Production</option>
                              <option value="Sunflower">Rice Production</option>
                              <option value="Sunflower">Watermelon Production</option>
                            </Field>
                        </div>
                    </div>
                </div>
                
                <div className='w-full flex flex-col items-end justify-center'>
                    <button 
                        type='submit'
                        className={
                        !(dirty && isValid) ? 
                        "border-2 border-black p-2 bg-white bg-opacity-60 text-green-900 rounded-xl px-5 "
                        : 'border-2 border-green-700 p-3 bg-green-400 bg-opacity-80 text-primary rounded-xl px-5'
                        }>
                            {
                                loading ? "Registering... " : "Register"
                            } 
                    </button>
                </div> 
            </Form>
        )}
           
      </Formik> 
    </animated.div> 
  )
}

export default Register
